/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import api from './api';

const path = 'activeSite';

export const get = async () => {
    return api.get(path);
};

export const setID = async (id) => {
    return api.patch(path, { id });
};
